/**
 * Base path for account settings
 */
export const SETTINGS_PREFIX = '/account';
/**
 * Base path for organization settings
 */
//# sourceMappingURL=constants.js.map